import { NavLink, Outlet } from "react-router-dom";
import { LogInIcon, LogOutIcon, UserIcon } from "lucide-react";
import { useAuth } from "@/client/lib/auth-context";
import ThemeToggle from "@/client/components/derived/ThemeToggle";
import { Button } from "@/client/components/base/button";
import { cn } from "@/client/utils/index";

const NAV_ITEMS = [
    { label: "Trackers", to: "/trackers" },
    { label: "Scanners", to: "/scanners" },
    { label: "Strategies", to: "/strategies" },
    { label: "Positions", to: "/positions" },
    { label: "Analysis", to: "/analysis" },
] as const;

const AppLayout = () => {
    const { isAuthenticated, logout } = useAuth();

    return (
        <div className="flex min-h-svh flex-col bg-background">
            <header className="sticky top-0 z-40 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80">
                <div className="mx-auto flex h-14 w-full max-w-7xl items-center gap-6 px-4 sm:px-6">
                    <NavLink to="/" className="shrink-0 text-lg font-bold tracking-tight text-foreground">
                        Alpha<span className="text-primary">grid</span>
                    </NavLink>

                    <nav aria-label="Primary" className="flex items-center gap-1">
                        {NAV_ITEMS.map(({ label, to }) => (
                            <NavLink
                                key={to}
                                to={to}
                                className={({ isActive }) =>
                                    cn(
                                        "rounded-lg px-3 py-1.5 text-sm font-medium transition-colors",
                                        isActive
                                            ? "bg-muted text-foreground"
                                            : "text-muted-foreground hover:bg-muted/60 hover:text-foreground"
                                    )
                                }
                            >
                                {label}
                            </NavLink>
                        ))}
                    </nav>

                    <div className="ml-auto flex items-center gap-2">
                        {isAuthenticated ? (
                            <>
                                <Button variant="ghost" size="sm" nativeButton={false} render={<NavLink to="/me" />}>
                                    <UserIcon data-icon="inline-start" />
                                    Account
                                </Button>
                                <Button variant="outline" size="sm" onClick={logout}>
                                    <LogOutIcon data-icon="inline-start" />
                                    Log out
                                </Button>
                            </>
                        ) : (
                            <Button variant="outline" size="sm" nativeButton={false} render={<NavLink to="/login" />}>
                                <LogInIcon data-icon="inline-start" />
                                Log in
                            </Button>
                        )}
                        <ThemeToggle />
                    </div>
                </div>
            </header>

            <main className="flex flex-1 flex-col">
                <Outlet />
            </main>
        </div>
    );
};

export default AppLayout;
